<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.prenatalConsultations', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
<!--                <div class="p-1em">-->
<!--                    <h3 class="card-title text-center mb-0">-->
<!--                        {{obstetricConsultationInformation}}-->
<!--                    </h3>-->
<!--                </div>-->

                <b-form  @reset="onReset" v-if="show">
                    <b-container>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group
                                        id="single-group"
                                        :label="$tc('message.typeOfConsultation', 1)"
                                        label-for="single"
                                >
                                    <select id="single" v-model="$v.form.type_de_consultation.$model" required
                                            @change="clearErrorField('type_de_consultation')"
                                            class="form-control is-invalid retirerBordure"
                                    >
                                        <option :value="form.type_de_consultation" selected>{{form.type_de_consultation}}</option>
                                        <option v-for="item in mTypeOfConsultation"  :key="item.id" :value="item.value">
                                            {{ item.text }}
                                        </option>
                                    </select>
                                    <b-form-invalid-feedback v-if="$v.form.type_de_consultation.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('type_de_consultation')" style="color:red">
                                    {{getErrorsField('type_de_consultation')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group
                                        id="complaints-group"
                                        :label="$tc('message.complaints',2)"
                                        label-for="complaints"
                                >
                                    <b-form-textarea
                                            id="complaints"
                                            v-model="$v.form.plaintes.$model"
                                            :state="$v.form.plaintes.$dirty ? !$v.form.plaintes.$error : null"
                                            placeholder=""
                                            @keydown="clearErrorField('plaintes')"
                                    ></b-form-textarea>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <span v-if="errorshasField('plaintes')" style="color:red">
                                    {{getErrorsField('plaintes')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="recommendations-group"
                                        :label="$tc('message.recommendations',2)"
                                        label-for="recommandations"
                                >
                                    <b-form-textarea
                                            id="recommandations"
                                            v-model="$v.form.recommandations.$model"
                                            :state="$v.form.recommandations.$dirty ? !$v.form.recommandations.$error : null"
                                            placeholder=""
                                            @keydown="clearErrorField('recommandations')"
                                    ></b-form-textarea>

                                    <b-form-invalid-feedback>
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <span v-if="errorshasField('recommandations')" style="color:red">
                                    {{getErrorsField('recommandations')}}
                                    </span>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>

                            <b-col sm="12">

                                <b-form-group
                                        id="clinique-group"
                                        :label="$tc('message.physicalExams', 2)"
                                        label-for="clinique"
                                >
                                    <b-form-textarea
                                            id="clinique"
                                            v-model="$v.form.examen_clinique.$model"
                                            :state="$v.form.examen_clinique.$dirty ? !(errorshasField('examen_clinique') || $v.form.examen_clinique.$error) : null"
                                            rows="5"
                                            @focus="clearErrorField('examen_clinique')"
                                    ></b-form-textarea>

                                    <b-form-invalid-feedback v-if="errorshasField('examen_clinique')">
                                        {{ getErrorsField('examen_clinique') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12">
                                <b-form-group
                                        id="complementaire-group"
                                        :label="$tc('message.complementaryExams', 2)"
                                        label-for="complementaire"
                                >
                                    <b-form-textarea
                                            id="complementaire"
                                            v-model="$v.form.examen_complementaire.$model"
                                            :state="$v.form.examen_complementaire.$dirty ? !(errorshasField('examen_complementaire') || $v.form.examen_complementaire.$error) : null"
                                            rows="5"
                                            @focus="clearErrorField('examen_complementaire')"
                                    ></b-form-textarea>

                                    <b-form-invalid-feedback v-if="errorshasField('examen_complementaire')">
                                        {{ getErrorsField('examen_complementaire') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>

                    </b-container>
                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.edit') }}
                            </b-button>

<!--                            <b-button type="reset" variant="danger">-->
<!--                                {{ $t('message.reset') }}-->
<!--                            </b-button>-->
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import SlimSelect from 'slim-select';

    export default {
        name: "EditPrenatal",

        computed: {
            ...mapGetters(["prenatalConsultation",'errors']),

            form: function() {
                return this.prenatalConsultation;
            },

            obstetricConsultationInformation:function(){
                if (typeof (this.form.user) == 'object'){
                    let user = this.form.user;
                    let prenom = (user.prenom != null ? user.prenom : '');
                    prenom =  prenom.toLowerCase();
                    let nom =  ( user.nom ).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                    let dossier = this.form.dossier;

                    return   nom + ' ( ' + dossier.numero_dossier+' ) - ' +this.form.consultation_obstetrique.numero_grossesse;
                }else{
                    return '';
                }
            },

            mTypeOfConsultation: function() {
                let sArray = [
                    {text:'1 CPN' ,value:'1 CPN',id:0},
                    {text:'2 CPN' ,value:'2 CPN',id:1},
                    {text:'3 CPN' ,value:'3 CPN',id:2},
                    {text:'4 CPN' ,value:'4 CPN',id:3},
                    {text:'5 CPN' ,value:'5 CPN',id:4},
                    {text:'6 CPN' ,value:'6 CPN',id:5},
                    {text:'7 CPN' ,value:'7 CPN',id:6},
                    {text:'8 CPN' ,value:'8 CPN',id:7},
                    {text:'9 CPN' ,value:'9 CPN',id:8},
                    {text:'10 CPN' ,value:'10 CPN',id:9},
                    {text:'11 CPN' ,value:'11 CPN',id:10},
                    {text:'12 CPN' ,value:'12 CPN',id:11},
                ];
                return sArray;
            }
        },

        data() {
            return {
                consultation_id: this.$route.params.consultation,
                show: true,
            }
        },

        methods: {
            getConsultation: function() {
                let args = {
                    consultation: this.consultation_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getPrenatalConsultation', { args, errorMessages });
            },
            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        consultation_obstetrique_id:this.form.consultation_obstetrique_id,
                        type_de_consultation: this.form.type_de_consultation,
                        plaintes: this.form.plaintes,
                        examen_clinique: this.form.examen_clinique,
                        examen_complementaire: this.form.examen_complementaire,
                        recommandations: this.form.recommandations,
                        consultation: this.consultation_id,
                    };

                    let successMessage = this.$i18n.t('message.prenatalConsultationUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updatePrenatalConsultation', { args, errorMessages, successMessage });
                }
            },

            onReset: function(evt) {
                // evt.preventDefault();
                //
                // // Reset our form values
                // // this.form.numero_grossesse = '';
                // this.consultation_obstetrique_id='';
                // this.typeOfConsultation= '';
                // this.complaints= '';
                // this.antecedentSpouse= '';
                // this.recommendations= '';
                // this.form.examen_clinique = '';
                // this.form.examen_complementaire = '';
                // // Trick to reset/clear native browser form validation state
                // this.show = false;
                //
                // this.$nextTick(() => {
                //     this.show = true;
                // });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },
            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },
            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                type_de_consultation:{
                    required
                },
                consultation_obstetrique_id: {
                    required
                },
                plaintes: {
                    //
                },
                examen_clinique: {
                    //
                },

                examen_complementaire: {
                    //
                },

                recommandations: {
                    //
                },
            }
        },
        mounted() {
            // Retrieve consultation
            this.getConsultation();
            new SlimSelect({
                select: '#single',
                placeholder: 'Select the consultation type',

            })
        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>